<template>
  <div>
    <div class="head-box">
      <h4 class="c-flex c-flex-item">
        信用账户
      </h4>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="搜索信用账户名称/编号"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click.native="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          v-if="osg.has('PartnerCredit,export')"
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'fpi-regex:name|string#or': searchValue,
                'fpi-regex:code|string#or': searchValue,
                'in:state|array-integer#and': '0,1',
                beanName: 'partnerCredit',
                title: '信用账户管理'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <!-- <div class="content-filter">
        <c-filter></c-filter>
      </div> -->
      <div class="content-table">
        <el-table ref="table" :data="fpi.data" empty-text="暂无数据" height="calc(100% - 50px)">
          <c-table :fields="extFields"></c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="osg.has('PartnerCredit,edit') || true"
                    @click.native="doEdit(scope.row)"
                  >
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('PartnerCredit,recharge')"
                    @click.native="rechargeClick(scope.row)"
                  >
                    返款充值
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('PartnerCredit,detail')"
                    @click.native="amountDetailsClick(scope.row._id)"
                  >
                    查看金额明细
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('PartnerCredit,type')"
                    @click.native="typeClick(scope.row)"
                  >
                    调整使用返利比例
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="信用账户管理" :visible.sync="openDetail">
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :upload="upload"
        :options="options"
        ref="form"
        labelWidth="150px"
        @changeForm="osg.changeForm"
      ></c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="返款充值" :visible.sync="recharge.show">
      <el-form
        ref="rechargeForm"
        :model="recharge.formData"
        :rules="rules"
        label-width="120px"
        label-position="left"
        hide-required-asterisk
      >
        <el-form-item label="账户名称" prop="name">
          <el-input v-model="recharge.formData.name" type="textare" disabled></el-input>
        </el-form-item>
        <el-form-item
          label="返款金额"
          prop="amount"
          :rules="{
            required: true,
            message: '请输入返款金额',
            trigger: 'change'
          }"
        >
          <el-input-number
            v-model="recharge.formData.amount"
            :controls="false"
            :precision="2"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="返款类型"
          prop="event"
          :rules="{
            required: true,
            message: '请选择返款类型',
            trigger: 'change'
          }"
        >
          <el-select v-model="recharge.formData.event" placeholder="请选择返款类型">
            <el-option
              v-for="(item, i) in options.rechargeEvent"
              :key="i"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="memo">
          <el-input v-model="recharge.formData.memo" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="rechargeSave">确 定</el-button>
        <el-button @click="rechargeInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="信用账户金额明细"
      :visible.sync="amountDetails.show"
      width="1000px"
      class="amountDetails-dialog"
      :close-on-click-modal="false"
    >
      <el-table
        ref="amountDetails"
        :data="amountDetails.fpi.data"
        highlight-current-row
        border
        class="c-table-border"
      >
        <c-table :fields="itemFields"></c-table>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="amountDetails.fpi.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="amountDetails.fpi.rows"
        layout="total, sizes, prev, pager, next, jumper"
        :total="amountDetails.fpi.total"
      ></el-pagination>
    </el-dialog>
    <el-dialog title="调整使用返利比例" :visible.sync="type.show">
      <el-form
        ref="typeForm"
        :model="type.formData"
        :rules="rules"
        label-width="120px"
        label-position="left"
        hide-required-asterisk
      >
        <el-form-item label="账户名称" prop="name">
          <el-input v-model="type.formData.name" type="textare" disabled></el-input>
        </el-form-item>
        <el-form-item
          label="使用返利比例"
          prop="type"
          :rules="{
            required: true,
            message: '请输入使用返利比例 0~100',
            trigger: 'change'
          }"
        >
          <el-input-number
            v-model="type.formData.type"
            :controls="false"
            :precision="0"
            :min="0"
            :max="100"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="typeSave">确 定</el-button>
        <el-button @click="typeInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'PartnerCredit',
  data() {
    window.$this = this;
    return {
      name: 'partnerCredit',
      fpi: { data: [] },
      searchValue: '',
      openDetail: false,
      extFields: [],
      formData: {
        exts: {}
      },
      rules: this.$util.rules,
      options: {
        codecfg_rechargeEvent: { codeId: 'rechargeEvent' }
      },
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      itemFields: [],
      amountDetails: { show: false, id: '', fpi: { page: 1, rows: 20, data: [] } },
      recharge: { show: false, formData: {} },
      type: { show: false, formData: {} }
    };
  },
  mounted() {
    this.osg.getFields('partnerCredit', () => {
      this.osg.getFpi();
      this.getData();
    });
    this.osg.getFields('partnerCreditItem', () => {}, null, 'itemFields');
  },
  methods: {
    pageSizeChange(pageSize) {
      if (this.amountDetails.show) {
        this.amountDetails.fpi.rows = pageSize;
        this.getAmountDetails();
      } else {
        this.fpi.rows = pageSize;
        this.getData();
      }
    },
    pageChange(currentPage) {
      if (this.amountDetails.show) {
        this.amountDetails.fpi.page = currentPage;
        this.getAmountDetails();
      } else {
        this.fpi.page = currentPage;
        this.getData();
      }
    },
    getData() {
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'in:state|array-integer#and': '0,1',
        'regex:name|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      // window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('/basic/partnerCredit/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doEdit(row) {
      this.formData = this.$util.deepCopy(row);
      this.openDetail = true;
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        exts: {}
      };
    },
    doSave() {
      if (this.osg.validate()) {
        this.osg.ajax(
          'basic/partnerCredit/update.do',
          { data: JSON.stringify(this.formData) },
          () => {
            this.osg.toast('保存成功');
            this.doInit();
            this.getData();
          }
        );
      }
    },
    /**
     * 返款充值
     */
    rechargeClick(row) {
      this.$refs.rechargeForm && this.$refs.rechargeForm.clearValidate();
      this.rechargeInit();
      this.recharge.formData.name = row.name;
      this.recharge.formData.creditId = row._id;
      this.recharge.show = true;
    },
    rechargeSave() {
      if (this.osg.validate('rechargeForm')) {
        this.osg.ajax(
          '/basic/partnerCredit/recharge.do',
          {
            creditId: this.recharge.formData.creditId,
            amount: this.recharge.formData.amount,
            memo: this.recharge.formData.memo || null,
            event: this.recharge.formData.event
          },
          () => {
            this.osg.toast('返款充值成功');
            this.rechargeInit();
            this.getData();
          }
        );
      }
    },
    rechargeInit() {
      this.recharge = { show: false, formData: {} };
    },
    /**
     * 查看金额明细
     */
    amountDetailsClick(id) {
      this.amountDetails.id = id;
      this.amountDetails.show = true;
      this.getAmountDetails();
    },
    getAmountDetails() {
      this.amountDetails;
      this.osg.ajax(
        'basic/partnerCreditItem/query.do',
        {
          page: this.amountDetails.page,
          rows: this.amountDetails.rows,
          partnerCreditId: this.amountDetails.id
        },
        res => {
          this.amountDetails.fpi = res;
          this.$nextTick(() => {
            this.$refs.amountDetails.doLayout();
            this.$forceUpdate();
          });
        }
      );
    },
    /**
     * 调整使用返利比例
     */
    typeClick(row) {
      this.$refs.typeForm && this.$refs.typeForm.clearValidate();
      this.typeInit();
      this.type.formData = this.$util.deepCopy(row);
      this.type.formData.type = this.type.formData.type || 0;
      this.type.show = true;
    },
    typeSave() {
      if (this.osg.validate('typeForm')) {
        this.osg.ajax(
          '/basic/partnerCredit/updateType.do',
          {
            id: this.type.formData._id,
            type: this.type.formData.type
          },
          () => {
            this.osg.toast('调整成功');
            this.typeInit();
            this.getData();
          }
        );
      }
    },
    typeInit() {
      this.type = { show: false, formData: {} };
    }
  }
};
</script>
